import { render } from "./NotificationCard.vue?vue&type=template&id=c851e2a2"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mobilemediaru/cashforapp/cashforapp_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__